(function () {
	'use strict';
	var controllerId = 'stakDomandaLoad';

	angular.module('app').controller(controllerId, ['$scope', '$uibModalInstance', 'datacontext', 'sectionMenu', 'FileUploader', 'testId', 'tipoTest', stakDomandaLoad]);

	function stakDomandaLoad($scope, $uibModalInstance, datacontext, sectionMenu, FileUploader, testId, tipoTest) {
        
	    $scope.MaxDim = '40'; //40 MB
	    $scope.upload_URL = datacontext.upload_getURL();
	    $scope.test = {};
	    $scope.test.Id = testId;
	    $scope.ext = null;
	    $scope.tipoTest = tipoTest;

		$scope.ok = function (isValid) {
			if (isValid) {
			    var result = loadItem($scope.test, $scope.ext);
				$uibModalInstance.close(result);
			}
		};

		$scope.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};		

		function loadItem(item, ext) {
		    //return file.value;
		    return datacontext.question_load(item, ext).then(function (data) {
		        if (!data || data.Id == null || data.Id == 0) return null;

		        return data;
		    });
		}

        $scope.removeFile = function (item) {
            $('#inputFile').val("");
            return false;
        };

        $scope.getMaterie = function (ricerca) {
            $scope.test.materia = ricerca;
            return datacontext.materia_getAll(0, 0, ricerca).then(function (data) {
                if (Array.isArray(data) && data.length > 0) {
                    $scope.materie = data;
                    return $scope.materie;
                }
                return null;
            });
        };

        $scope.setMateriaId = function (materia) {
            $scope.test.materiaId = materia.Id;
            $scope.test.materia = materia.Titolo;
        };

        $scope.checkMateria = function () {
            if (!$scope.test.materia)
                $scope.test.materiaId = 0;
        };

	    // FILTERS
		var uploader = $scope.uploader = new FileUploader({
		    url: $scope.upload_URL
		}
			);

		uploader.filters.push({
		    name: 'customFilter',
		    fn: function (item /*{File|FileLikeObject}*/, options) {
		        return this.queue.length < 10;
		    }
		});

	    // CALLBACKS

		uploader.onWhenAddingFileFailed = function (item /*{File|FileLikeObject}*/, filter, options) {
		    /*
        	console.info('onWhenAddingFileFailed', item, filter, options);
        	console.log('onWhenAddingFileFailed - end');
            */
		};
		uploader.onAfterAddingFile = function (fileItem) {
		    /*
        	console.info('onAfterAddingFile', fileItem);
        	console.log('onAfterAddingFile - end');
        	console.dir(fileItem);
            */
		};
		uploader.onAfterAddingAll = function (addedFileItems) {
		    /*
        	console.info('onAfterAddingAll', addedFileItems);
        	console.log('onAfterAddingAll - end');
            */
		};
		uploader.onBeforeUploadItem = function (item) {
		    /*
            console.info('onBeforeUploadItem', item);
            console.log('onBeforeUploadItem');
            */
		};
		uploader.onProgressItem = function (fileItem, progress) {
		    /*
            console.info('onProgressItem', fileItem, progress);
        	console.log('onProgressItem - end');
        	console.dir(progress);
            */
		};
		uploader.onProgressAll = function (progress) {
		    /*
        	console.info('onProgressAll', progress);
        	console.log('onProgressAll - end');
            */
		};
		uploader.onSuccessItem = function (fileItem, response, status, headers) {
		    //console.dir(response);
		    if (response != null && response.length > 0) {
		        var data = response[0];
		        $scope.test.ImportExcel = data.PathServer;
		        $scope.ext = data.Extension;

		        //$scope.attach.Name = data.NameOrig;
		        //$scope.attach.KB = data.Length;
		        //$scope.attach.uploaded = true;
		    }

		};
		uploader.onErrorItem = function (fileItem, response, status, headers) {
		    /*
            console.info('onErrorItem', fileItem, response, status, headers);
        	console.log('onErrorItem - end');
            */
		};
		uploader.onCancelItem = function (fileItem, response, status, headers) {
		    /*
        	console.info('onCancelItem', fileItem, response, status, headers);
        	console.log('onCancelItem - end');
            */
		};
		uploader.onCompleteItem = function (fileItem, response, status, headers) {
		    /*
        	console.info('onCompleteItem', fileItem, response, status, headers);
        	console.log('onCompleteItem - end');
            */
		};
		uploader.onCompleteAll = function () {
		    /*
        	console.info('onCompleteAll');
        	console.log('onCompleteAll - end');
            */
		};

	}
})();